import { Component } from '@angular/core';

@Component({
  selector: 'siu-simple-skeleton',
  templateUrl: './simple-skeleton.component.html',
  styleUrls: [ './simple-skeleton.component.css' ]
})
export class SimpleSkeletonComponent {

  constructor() { }
}
